import isURL from 'validator/lib/isURL';

import {
  AlignEnum,
  ButtonTypeAction,
  FontSizeEnum,
  LineMessageBlockType,
  ManualUrlAction,
  UrlAction,
  UrlActionType,
  VariableUrlAction,
} from './types';
import {
  ButtonTypeBlock,
  ImageTypeBlock,
  ImageVideoBlock,
  PlainTextBlock,
  PostbackAction,
  RichMessageBlock,
} from './types';

export const isValidActionURL = (url = '') => {
  return isURL(url, {
    protocols: ['http', 'https', 'tel'],
    require_protocol: true,
  });
};

export const createManualActionURL = (url?: string): UrlAction => ({
  status: UrlActionType.enum.MANUAL,
  manual: url || '',
});

export const createVariableActionURL = (variable?: string): UrlAction => ({
  status: UrlActionType.enum.VARIABLE,
  variable: variable || '',
});

export const isManualActionURL = (urlAction?: UrlAction): urlAction is ManualUrlAction => {
  return urlAction?.status === UrlActionType.enum.MANUAL;
};

export const isVariableActionURL = (urlAction?: UrlAction): urlAction is VariableUrlAction => {
  return urlAction?.status === UrlActionType.enum.VARIABLE;
};

export const getManualActionURL = (urlAction?: UrlAction): string | undefined => {
  return urlAction?.status === UrlActionType.enum.MANUAL ? urlAction.manual : '';
};

export const getVariableActionURL = (urlAction?: UrlAction): string | undefined => {
  return urlAction?.status === UrlActionType.enum.VARIABLE ? urlAction.variable : '';
};

export const DEFAULT_PLAIN_TEXT_BLOCK: PlainTextBlock = {
  type: LineMessageBlockType.enum.PLAIN_TEXT,
  text: '',
  richText: undefined,
};

export const DEFAULT_RICH_MESSAGE_BLOCK: RichMessageBlock = {
  type: LineMessageBlockType.enum.RICH,
  image: undefined,
  actionUrl: createManualActionURL(),
};

export const DEFAULT_IMAGE_TYPE_BLOCK_CARD: ImageTypeBlock['cards'][0] = {
  image: undefined,
  actionLabel: '',
  actionUrl: createManualActionURL(),
};

export const DEFAULT_IMAGE_TYPE_BLOCK: ImageTypeBlock = {
  type: LineMessageBlockType.enum.IMAGES,
  cards: [DEFAULT_IMAGE_TYPE_BLOCK_CARD, DEFAULT_IMAGE_TYPE_BLOCK_CARD],
};

export const DEFAULT_BUTTON_TYPE_BLOCK_CARD_ACTION: ButtonTypeAction = {
  postbackAction: PostbackAction.enum.URL_MANUAL,
  label: '',
  url: '',
  urlVariable: '',
};

export const DEFAULT_BUTTON_TYPE_BLOCK_CARD: ButtonTypeBlock['cards'][0] = {
  image: undefined,
  title: {
    text: '',
    weighted: true,
    fontSize: FontSizeEnum.enum.lg,
    align: AlignEnum.enum.start,
    richText: undefined,
  },
  description: {
    text: '',
    weighted: false,
    fontSize: FontSizeEnum.enum.sm,
    align: AlignEnum.enum.start,
    richText: undefined,
  },
  actions: [DEFAULT_BUTTON_TYPE_BLOCK_CARD_ACTION],
  isImageBelowDescription: false,
};

export const DEFAULT_BUTTON_TYPE_BLOCK: ButtonTypeBlock = {
  type: LineMessageBlockType.enum.BUTTON,
  cards: [DEFAULT_BUTTON_TYPE_BLOCK_CARD, DEFAULT_BUTTON_TYPE_BLOCK_CARD],
};

export const DEFAULT_IMAGE_VIDEO_BLOCK: ImageVideoBlock = {
  type: LineMessageBlockType.enum.IMAGE_VIDEO,
};

export const getDefaultBlockByType = (type: LineMessageBlockType) => {
  if (type === 'PLAIN_TEXT') return DEFAULT_PLAIN_TEXT_BLOCK;
  if (type === 'RICH') return DEFAULT_RICH_MESSAGE_BLOCK;
  if (type === 'IMAGES') return DEFAULT_IMAGE_TYPE_BLOCK;
  if (type === 'BUTTON') return DEFAULT_BUTTON_TYPE_BLOCK;
  if (type === 'IMAGE_VIDEO') return DEFAULT_IMAGE_VIDEO_BLOCK;

  return {
    type,
  };
};
